module.exports = __webpack_public_path__ + "img/KinokoTable54.730614d0.jpg";